export default __webpack_public_path__ + "static/media/carousel5.c7959f95.jpeg";